export default "__VITE_ASSET__Dt25d06n__"